import { api } from "@convex/_generated/api";
import { useQuery } from "convex/react";
import type { ReactNode } from "react";
import { authClient } from "./auth-client";
import { type Org, OrgContext } from "./org-context";

export { type Org, useOrg } from "./org-context";

/** Renders `fallback` until the session and the org list have loaded. */
export const OrgProvider = ({ children, fallback }: { children: ReactNode; fallback: ReactNode }) => {
  const session = authClient.useSession();
  const orgs = useQuery(api.orgs.mine);
  const activeId = session.data?.session.activeOrganizationId ?? null;
  if (session.data === null || session.data === undefined || orgs === undefined) return fallback;
  const active = orgs.find((org) => org.orgId === activeId) ?? orgs[0];
  if (active === undefined) return fallback;
  const value: Org = {
    id: active.orgId,
    name: active.name,
    userId: session.data.user.id,
    userName: session.data.user.name,
    role: active.role,
  };
  return <OrgContext value={value}>{children}</OrgContext>;
};
